export const common = {
  nav: {
    services: 'Services',
    about: 'About',
    whyUs: 'Why Us',
    portfolio: 'Portfolio',
    contact: 'Contact'
  },
  hero: {
    headline: 'Smart Digital Solutions to Elevate Your Business',
    subheadline: 'We bridge ideas and technology to help your business grow',
    ctaPrimary: 'Get a Free Consultation',
    ctaSecondary: 'View Our Services'
  },
  services: {
    title: 'What We Offer',
    subtitle: 'Comprehensive digital solutions tailored to your business needs',
    websites: {
      title: 'Websites',
      description: 'Responsive, modern, conversion-focused websites that drive results'
    },
    branding: {
      title: 'Branding & Visual Identity',
      description: 'Logo design, brand kits, and visual consistency for your business'
    },
    printing: {
      title: 'Printing',
      description: 'Business cards, flyers, banners, and marketing materials'
    },
    itSupport: {
      title: 'IT & Digital Support',
      description: 'Tech support, setup, maintenance, and ongoing help'
    }
  },
  websites: {
    title: 'Web Design That Converts',
    subtitle: 'We design fast, responsive, and visually engaging websites focused on user experience and business growth.',
    portfolio: {
      title: 'Our Website Projects',
      subtitle: 'Real websites we\'ve built for real businesses',
      livePreview: 'Live Preview',
      responsive: 'Fully responsive on all devices',
      comingSoon: 'More Projects Coming Soon'
    },
    projects: {
      miunaesperanzaviva: {
        name: 'Mi Una Esperanza Viva',
        description: 'Faith-based organization website with clean design and structured content.'
      },
      suadicor: {
        name: 'Suadicor',
        description: 'Service-based business website focused on clarity and lead generation.'
      }
    },
    cta: {
      title: 'Want a website like this? Let\'s build yours.',
      quote: 'Request a Website Quote',
      whatsapp: 'Chat on WhatsApp'
    }
  },
  about: {
    title: 'About BridgeOn Solutions',
    description: 'We are a digital creative agency dedicated to helping small and medium businesses in the U.S. thrive in the digital world. With a focus on quality, innovation, and reliability, we bridge the gap between your vision and cutting-edge technology. Our mission is to deliver custom solutions that not only meet your needs but exceed your expectations, driving real business growth.'
  },
  whyUs: {
    title: 'Why Choose Us',
    subtitle: 'What makes us different',
    custom: {
      title: 'Custom Solutions',
      description: 'Tailored strategies designed specifically for your business goals'
    },
    support: {
      title: 'Reliable Support',
      description: '24/7 assistance to keep your business running smoothly'
    },
    technology: {
      title: 'Modern Technology',
      description: 'Cutting-edge tools and platforms for optimal performance'
    },
    results: {
      title: 'Business-Focused Results',
      description: 'Data-driven approach that delivers measurable growth'
    }
  },
  contact: {
    title: 'Let\'s Work Together',
    subtitle: 'Ready to elevate your business? Get in touch with us today',
    form: {
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company (optional)',
      service: 'Service Needed',
      message: 'Message',
      submit: 'Send Message',
      selectService: 'Select a service',
      services: {
        websites: 'Websites',
        branding: 'Branding',
        printing: 'Printing',
        itSupport: 'IT & Digital Support'
      }
    },
    info: {
      email: 'Email',
      phone: 'Phone',
      website: 'Website'
    },
    whatsapp: 'Chat on WhatsApp'
  },
  footer: {
    tagline: 'Bridging ideas and technology',
    quickLinks: 'Quick Links',
    followUs: 'Follow Us',
    copyright: '© 2025 BridgeOn Solutions. All rights reserved.',
    poweredBy: 'Website Builder'
  }
};